import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '@services/dashboardService';

const QUERY_KEY = 'dashboard';

export const useDashboard = ({ startDate, endDate } = {}) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [QUERY_KEY, startDate, endDate],
    queryFn: () => dashboardService.getData({ startDate, endDate }),
    refetchInterval: 60000,
    enabled: !!startDate && !!endDate,
  });

  return {
    data: data || {
      currentBalance: 0,
      monthSummary: { income: 0, expense: 0, balance: 0 },
      accounts: [],
      recentTransactions: [],
      upcomingBills: [],
      categoryCount: { income: 0, expense: 0 },
    },
    isLoading,
    error,
    refetch,
  };
};

export default useDashboard;
